'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleUGCDisplay = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _rating = require('@bibliocommons/rating');

var _rating2 = _interopRequireDefault(_rating);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcon = require('@bibliocommons/base-icon');

var _baseIcon2 = _interopRequireDefault(_baseIcon);

var _baseButtons = require('@bibliocommons/base-buttons');

var _privacyToggle = require('../../privacy-toggle');

var _privacyToggle2 = _interopRequireDefault(_privacyToggle);

require('../styles/SimpleUGCDisplay.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleUGCDisplay = exports.SimpleUGCDisplay = function (_BcReactComponent) {
  _inherits(SimpleUGCDisplay, _BcReactComponent);

  function SimpleUGCDisplay(props) {
    _classCallCheck(this, SimpleUGCDisplay);

    var _this = _possibleConstructorReturn(this, (SimpleUGCDisplay.__proto__ || Object.getPrototypeOf(SimpleUGCDisplay)).call(this, props));

    _this.bindAll('renderRating');
    return _this;
  }

  _createClass(SimpleUGCDisplay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {/* For testing */}
  }, {
    key: 'renderRating',
    value: function renderRating() {
      var _props = this.props,
          user = _props.user,
          rating = _props.rating;

      if (user.name && rating > 0) {
        return _react2.default.createElement(
          'div',
          { className: 'user-rating' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'users_rating',
            values: {
              username: user.name,
              rating: _react2.default.createElement(_rating2.default, { rating: rating }),
              type: 'blue'
            } })
        );
      }
      return null;
    }
  }, {
    key: 'renderUGCActions',
    value: function renderUGCActions() {
      var _props2 = this.props,
          handleShowForm = _props2.handleShowForm,
          handleDelete = _props2.handleDelete,
          bibId = _props2.bibId,
          isPrivate = _props2.isPrivate,
          handlePrivacyToggle = _props2.handlePrivacyToggle;


      return _react2.default.createElement(
        'div',
        { className: 'ugc-actions' },
        _react2.default.createElement(
          _baseButtons.TextButton,
          { handleClick: handleShowForm },
          _react2.default.createElement(_baseIcon2.default, { icon: 'icon-edit' }),
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'edit_button' })
        ),
        _react2.default.createElement(
          _baseButtons.TextButton,
          { handleClick: handleDelete },
          _react2.default.createElement(_baseIcon2.default, { icon: 'icon-trash' }),
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'delete_button' })
        ),
        _react2.default.createElement(_privacyToggle2.default, {
          bibId: bibId,
          showLabel: true,
          isPrivate: isPrivate,
          handlePrivacyToggle: handlePrivacyToggle })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          body = _props3.body,
          ugcType = _props3.ugcType;


      return _react2.default.createElement(
        'div',
        { className: 'cp-simple-ugc-display' },
        _react2.default.createElement(
          'div',
          { className: ugcType + ' preformat' },
          body
        ),
        this.renderRating(),
        this.renderUGCActions()
      );
    }
  }]);

  return SimpleUGCDisplay;
}(_baseBcReactComponent2.default);

SimpleUGCDisplay.propTypes = {
  body: _react.PropTypes.string.isRequired,
  ugcType: _react.PropTypes.string.isRequired,
  rating: _react.PropTypes.number,
  user: _react.PropTypes.shape({
    name: _react.PropTypes.string
  }),
  handleShowForm: _react.PropTypes.func.isRequired,
  handleDelete: _react.PropTypes.func.isRequired,
  bibId: _react.PropTypes.number.isRequired,
  handlePrivacyToggle: _react.PropTypes.func.isRequired,
  isPrivate: _react.PropTypes.bool.isRequired
};

SimpleUGCDisplay.defaultProps = {
  rating: 0,
  user: {}
};

exports.default = SimpleUGCDisplay;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/simple-ugc-display/components/SimpleUGCDisplay.js
// module id = 1536
// module chunks = 1